import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTenant } from '@/tenant/TenantProvider'
import { SlideProgressDots } from '@/components/slides/SlideProgressDots'
import { useSettingsStore } from '@/state/useSettingsStore'
import { now, nowInPrague } from '@/lib/clock'
import { formatDate, formatTime } from '@/lib/format'

export function Footer() {
  const { t } = useTranslation()
  const tenant = useTenant()
  const locale = useSettingsStore((s) => s.locale)
  const [, force] = useState(0)
  useEffect(() => {
    const id = window.setInterval(() => force((n) => n + 1), 1000)
    return () => window.clearInterval(id)
  }, [])
  const wall = nowInPrague()

  return (
    <footer className="flex items-center justify-between gap-6 px-8 pb-3 pt-2 text-xs text-ink-subtle">
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-surface-1/60 px-2 py-0.5 font-medium">
          <span className="relative flex size-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-signal-good opacity-60" />
            <span className="relative inline-flex size-1.5 rounded-full bg-signal-good" />
          </span>
          <span className="uppercase tracking-widest text-ink-muted">{t('header.live')}</span>
        </span>
        <span className="font-mono text-sm font-semibold tabular-nums text-ink">
          {formatTime(wall, locale)}
        </span>
        <span className="hidden sm:inline">·</span>
        <span className="hidden sm:inline">{formatDate(now(), locale)}</span>
        <span className="hidden md:inline">·</span>
        <span className="hidden md:inline">{tenant.name}</span>
      </div>
      <SlideProgressDots />
      <div className="flex items-center gap-3">
        <span className="hidden uppercase tracking-widest sm:inline">{t('settings.shortcut')}</span>
      </div>
    </footer>
  )
}
